import { create } from 'zustand';
import { InvitationInfoResponse } from '../api/invitationApi';

interface InvitationFlowState {
  // Core data
  invitationId: string | null;
  invitationInfo: InvitationInfoResponse | null;

  // Track step completion
  profileCaptured: boolean;
  consentGiven: boolean;
  businessDetailsCaptured: boolean;

  // Track if business details are required (for new users only)
  requiresBusinessDetails: boolean;

  // Actions
  setInvitationId: (id: string) => void;
  setInvitationInfo: (info: InvitationInfoResponse) => void;
  markProfileCaptured: () => void;
  markConsentGiven: () => void;
  markBusinessDetailsCaptured: () => void;
  setRequiresBusinessDetails: (requires: boolean) => void;
  reset: () => void;
}

export const useInvitationFlowStore = create<InvitationFlowState>(set => ({
  // Initial state
  invitationId: null,
  invitationInfo: null,
  profileCaptured: false,
  consentGiven: false,
  businessDetailsCaptured: false,
  requiresBusinessDetails: false,

  // Actions
  setInvitationId: id => set({ invitationId: id }),

  setInvitationInfo: info => set({ invitationInfo: info }),

  markProfileCaptured: () => set({ profileCaptured: true }),

  markConsentGiven: () => set({ consentGiven: true }),

  markBusinessDetailsCaptured: () => set({ businessDetailsCaptured: true }),

  setRequiresBusinessDetails: requires =>
    set({ requiresBusinessDetails: requires }),

  reset: () =>
    set({
      invitationId: null,
      invitationInfo: null,
      profileCaptured: false,
      consentGiven: false,
      businessDetailsCaptured: false,
      requiresBusinessDetails: false,
    }),
}));
